import { render } from "./Footer.vue?vue&type=template&id=fd029a16&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=fd029a16&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fd029a16"

export default script